import { MonitoringLizingOrgs } from "@/common/api.service";
import {
  FETCH_MONITORING_LIZING_ORGS,
  FETCH_MONITORING_LIZING_ORGS_LIST
} from "./actions.type";
import {
  FETCH_MONITORING_LIZING_ORGS_END,
  FETCH_MONITORING_LIZING_ORGS_START
} from "@/store/mutations.type";

const state = {
  monitoringLizingOrg: {},
  isMonitoringLizingOrgsLoading: false,
  monitoringLizingOrgs: []
};

const getters = {
  monitoringLizingOrg() {
    return state.monitoringLizingOrg;
  },
  isMonitoringLizingOrgsLoading() {
    return state.isMonitoringLizingOrgsLoading;
  },
  monitoringLizingOrgs() {
    return state.monitoringLizingOrgs;
  }
};

const actions = {
  async [FETCH_MONITORING_LIZING_ORGS]({ commit }, params) {
    await MonitoringLizingOrgs.getListOrgs(params)
      .then(({ data }) => {
        commit(FETCH_MONITORING_LIZING_ORGS_END, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  async [FETCH_MONITORING_LIZING_ORGS_LIST]({ commit }, params) {
    commit(FETCH_MONITORING_LIZING_ORGS_START);
    return MonitoringLizingOrgs.getListMonitoringLizingOrgs(params)
      .then(({ data }) => {
        commit(FETCH_MONITORING_LIZING_ORGS_END, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  }
};

const mutations = {
  [FETCH_MONITORING_LIZING_ORGS_START](state) {
    state.isMonitoringLizingOrgsLoading = true;
  },
  [FETCH_MONITORING_LIZING_ORGS_END](state, monitoringLizingOrgs) {
    state.monitoringLizingOrgs = monitoringLizingOrgs;
    state.isMonitoringLizingOrgsLoading = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
